import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import serviceWorkerUpdateManager from './utils/serviceWorkerUpdate';
import { installGoogleTranslateDomFix } from './utils/googleTranslateDomFix';

// Make React's DOM removal/insertion tolerant of the text-node replacements
// Google Translate performs, preventing "removeChild: node is not a child of
// this node" crashes app-wide. Installed before React renders anything.
installGoogleTranslateDomFix();

// Suppress the benign ResizeObserver loop notification that MUI + animated
// layouts occasionally surface in the browser's error overlay.
const _resizeObserverErrHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
    if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', _resizeObserverErrHandler);

// In production, silence non-essential console output (log/info/debug/trace).
// The app ships with ~200 debug statements; suppressing them removes their
// runtime/console overhead and avoids leaking internal details, while keeping
// console.warn / console.error so real problems are still reported.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Initialize service worker update manager (production only)
if (process.env.NODE_ENV === 'production') {
  serviceWorkerUpdateManager.initialize().catch((error) => {
    console.error('Failed to initialize service worker update manager:', error);
  });
} else {
  // In development, unregister any existing service workers to prevent conflicts
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('[Dev] Unregistered existing service worker');
          }
        });
      });
    });
    
    // Also clear all caches in development
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
